module.exports = __webpack_public_path__ + "static/media/1619810675986-removebg-preview.3a858808.png";